<div class="min-h-screen bg-[var(--color-app-bg)] text-[var(--color-text)]">
  @if(!isLoading()){
  <div data-testid="desktop-sidebar-wrapper" [class]="
          'hidden md:fixed md:inset-y-0 md:left-0 md:z-30 md:block md:transition-[width] md:duration-200 md:ease-out ' +
          (isSidebarCollapsed() ? 'md:w-[72px]' : 'md:w-[220px]')
        ">
    <app-sidebar [collapsed]="isSidebarCollapsed()" (toggleCollapse)="toggleSidebarCollapse()" />
  </div>

  <div data-testid="shell-content-wrapper" [class]="
          'flex min-h-screen min-w-0 flex-col md:transition-[padding-left] md:duration-200 md:ease-out ' +
          (isSidebarCollapsed() ? 'md:pl-[72px]' : 'md:pl-[220px]')
        ">
    <app-topbar  (menuClick)="mobileOpen.set(true)" />
    <main class="flex-1 px-5 py-6 md:px-4 md:py-4">
      @if (integrationRequired()) {
        <div class="mb-4 flex flex-wrap items-center justify-between gap-3 rounded-md border border-amber-300 bg-amber-50 px-4 py-3" role="alert">
          <div class="flex items-start gap-3">
            <svg class="mt-0.5 h-5 w-5 shrink-0 text-amber-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
              <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" />
            </svg>
            <div>
              <p class="text-sm font-semibold text-amber-900">İşlem gerekiyor</p>
              <p class="text-sm text-amber-800">Uygulamayı kullanabilmek için lütfen e-Fatura entegrasyon bilgilerinizi giriniz.</p>
            </div>
          </div>
          <button type="button"
            class="shrink-0 rounded-md bg-amber-600 px-3 py-1.5 text-sm font-semibold text-white transition-colors hover:bg-amber-700"
            (click)="openTutorial()">Bilgileri Gir</button>
        </div>
      }
      <router-outlet />
    </main>
  </div>

  @if (mobileOpen()) {
  <div class="fixed inset-0 z-40 md:hidden" role="dialog" aria-modal="true">
    <button class="absolute inset-0 bg-[var(--color-overlay)] backdrop-blur-sm" (click)="mobileOpen.set(false)"
      aria-label="Menuyu kapat"></button>
    <div class="absolute inset-y-0 left-0 w-[220px] shadow-2xl">
      <app-sidebar [mobile]="true" />
    </div>
  </div>
  }

  <app-command-palette />

  <!-- Paket yükseltme modalı — kilitli 'upgrade' özelliklerine tıklanınca (nav/rapor/buton) açılır. -->
  <app-upgrade-modal />



  <!-- @if (showLaunchModal()) {
    <div class="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm">
      <div class="mx-4 w-full max-w-md rounded-2xl bg-white p-8 text-center shadow-2xl">
        <div class="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-[#EEF2FF]">
          <svg class="h-8 w-8 text-[#3773fe]" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
          </svg>
        </div>
        <h2 class="mb-3 text-xl font-bold text-[#1E293B]">Teşekkürler!</h2>
        <p class="mb-5 text-sm leading-relaxed text-[#475569]">
          Entegrasyonu tamamladığınız için teşekkürler.
        </p>
        <div class="launch-msg-ticker">
          @for (msg of launchMessages; track msg; let i = $index) {
            <span class="launch-msg-item" [class.launch-msg-active]="i === currentMsgIndex()">{{ msg }}</span>
          }
        </div>
        <div class="mt-6 rounded-lg bg-[#F8FAFC] px-4 py-3">
          <p class="text-xs text-[#94A3B8]">Sistemimiz <strong>1 Nisan</strong>'da sizlerle.</p>
        </div>
      </div>
    </div>
  } -->
  }
  @else {
    <div style="display:flex;align-items:center;justify-content:center;height:100vh;background:#F5F6FA">
      <div style="width:2.5rem;height:2.5rem;border:3px solid #ECEEF2;border-top-color:#3773fe;border-radius:50%;animation:sp .8s linear infinite"></div>
    </div>
  }
</div>